var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19C1 21.3638 1.46558 23.7044 2.37017 25.8883C3.27475 28.0722 4.60062 30.0565 6.27208 31.7279C7.94353 33.3994 9.92784 34.7252 12.1117 35.6298C14.2956 36.5344 16.6362 37 19 37C21.3638 37 23.7044 36.5344 25.8883 35.6298C28.0722 34.7252 30.0565 33.3994 31.7279 31.7279C33.3994 30.0565 34.7252 28.0722 35.6298 25.8883C36.5344 23.7044 37 21.3638 37 19C37 16.6362 36.5344 14.2956 35.6298 12.1117C34.7252 9.92784 33.3994 7.94353 31.7279 6.27208C30.0565 4.60062 28.0722 3.27475 25.8883 2.37017C23.7044 1.46558 21.3638 1 19 1C16.6362 1 14.2956 1.46558 12.1117 2.37017C9.92784 3.27475 7.94353 4.60062 6.27208 6.27208C4.60062 7.94353 3.27475 9.92784 2.37017 12.1117C1.46558 14.2956 1 16.6362 1 19Z",
    stroke: "#16C270",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 20.125L17.125 25L26.125 15.25",
    stroke: "#16C270",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSuccess);
export default __webpack_public_path__ + "static/media/circle-success.78e51ae35f16709d3c8a847e0b0f5756.svg";
export { ForwardRef as ReactComponent };